import { SKILLS } from '../data/skills';
import { PageSection, SectionHeader } from './SectionHeader';

export default function Skills() {
  return (
    <PageSection id="skills">
      <SectionHeader
        index="04"
        label="Toolkit"
        title="What I <em>work</em> with."
        description="Grouped by where it sits in the stack, from training to serving."
      />

      <div className="grid md:grid-cols-2 gap-4">
        {SKILLS.map((group, i) => (
          <div
            key={group.category}
            className="card card-hover reveal p-7"
            style={{ '--d': `${i * 70}ms` }}
          >
            <div className="flex items-center justify-between">
              <h3 className="text-base font-medium text-ink">{group.category}</h3>
              <span className="font-mono text-[11px] text-faint">0{i + 1}</span>
            </div>
            <ul className="mt-6 flex flex-wrap gap-2">
              {group.items.map((item) => (
                <li
                  key={item}
                  className="rounded-lg border border-line bg-void px-3 py-1.5 text-[13px] text-muted hover:text-ink hover:border-line-2 transition-colors"
                >
                  {item}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </PageSection>
  );
}
